
import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { createPortal } from "react-dom"; // 為了插入自做的全螢幕按鈕到 Google Map Ref 需要調用這個。

import { Routes } from "../../routes";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import { } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Button, Dropdown, ButtonGroup, Image, Carousel, Alert } from '@themesberg/react-bootstrap';
import geoNow from '../../utils/geonow';
import { useSelector } from 'react-redux';
import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from '@react-google-maps/api';
import ProjectKmlLayers from '../../components/ProjectKmlLayers';
import moment from "moment-timezone";
import 'moment/locale/zh-tw';
import WhiteRiverPicture from '../../assets/img/whiteriverReservoirPanoramio.jpg';
import MarkerIconGreen from '../../assets/img/gmap-markers/marker_green.png';
import MarkerIconYellow from '../../assets/img/gmap-markers/marker_yellow.png';
import MarkerIconRed from '../../assets/img/gmap-markers/marker_red.png';

import FeatureErrorBoundary from '../../components/FeatureErrorBoundary';
import useDashboardResources from '../../hooks/useDashboardResources';
import queryString from 'query-string';
import { buildDashboardMapItems, isDashboardMapItem } from '../../utils/dashboardMapItems';
import { getStatusLightForScore, getStatusLogicMode, STATUS_LOGIC_MODES } from '../../utils/statusLights';


export default () => {

    // 自動把 src/assets/img/gmap-markers/presets/*.png 全部做成字典：{ [type]: { green|yellow|red: url } }
    const PRESET_ICONS = (() => {
        try {
            const ctx = require.context('../../assets/img/gmap-markers/presets', false, /\.png$/);
            const map = {};
            ctx.keys().forEach(k => {
                // k 例: "./SID-Green.png"
                const file = k.replace('./', '');          // "SID-Green.png"
                const [rawType, rawColorWithExt] = file.split('-'); // "SID", "Green.png"
                const type = rawType?.toUpperCase();
                const color = rawColorWithExt?.replace('.png', '')?.toLowerCase(); // green|yellow|red
                if (!type || !color) return;
                map[type] ??= {};
                map[type][color] = ctx(k);
            });
            return map;
        } catch (e) {
            console.error('[PRESET_ICONS] load failed:', e);
            return {};
        }
    })();
    function getPresetIconUrl(typeKey, warnLv) {
        const light = getStatusLightForScore(warnLv, selectedProject);
        const color = light.color;
        if (getStatusLogicMode(selectedProject) === STATUS_LOGIC_MODES.ALERT_ACTION) {
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><rect x="1" y="1" width="22" height="22" rx="2" fill="${light.background}" stroke="#374151"/><text x="12" y="17" text-anchor="middle" font-size="14" fill="${light.foreground}">${light.colorName}</text></svg>`;
            return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
        }
        const key = String(typeKey || '').toUpperCase();
        const byType = PRESET_ICONS[key];
        // 找不到專屬圖就退回通用的三色
        if (!byType || !byType[color]) {
            return color === 'yellow' ? MarkerIconYellow : (color === 'red' ? MarkerIconRed : MarkerIconGreen);
        }
        return byType[color];
    }

    const rdx_project = useSelector(state => state.project);
    let rdx_user = useSelector(state => state.user);
    let token = rdx_user.token;

    const [query, setQuery] = useState(null);
    let qs = queryString.parse(window.location.search);
    let qoProjectId = qs && qs.iniProjectId;
    let qoToken = qs && qs.token;
    let qoHideDashoTitle = qs && qs.hideDashoTitle;
    let qoHideDashoDesc = qs && qs.hideDashoDesc;
    let qoHideDashoImg = qs && qs.hideDashoImg;
    let qoPrependStatusGreenText = qs && qs.prependStatusGreenText;
    let qoPrependStatusYellowText = qs && qs.prependStatusYellowText;
    let qoPrependStatusRedText = qs && qs.prependStatusRedText;
    let qoOnlyShowPrependStatusText = qs && qs.onlyShowPrependStatusText;
    let qoDashoGmapZoom = qs && qs.dashoGMapZoom;
    let qoDashoGmapCenter = qs && qs.dashoGMapCenter;

    useEffect(() => {
        let qs = queryString.parse(window.location.search);
        let qoProjectId = qs && qs.iniProjectId;
        let qoToken = qs && qs.token;
        let qoHideDashoTitle = qs && qs.hideDashoTitle;
        let qoHideDashoDesc = qs && qs.hideDashoDesc;
        let qoHideDashoImg = qs && qs.hideDashoImg;
        let qoPrependStatusGreenText = qs && qs.prependStatusGreenText;
        let qoPrependStatusYellowText = qs && qs.prependStatusYellowText;
        let qoPrependStatusRedText = qs && qs.prependStatusRedText;
        let qoOnlyShowPrependStatusText = qs && qs.onlyShowPrependStatusText;
        let qoDashoGmapZoom = qs && qs.dashoGMapZoom;
        let qoDashoGmapCenter = qs && qs.dashoGMapCenter;
        let oQs = {
            projectId: qoProjectId,
            token: qoToken,
            hideDashoTitle: qoHideDashoTitle,
            hideDashoDesc: qoHideDashoDesc,
            hideDashoImg: qoHideDashoImg,
            prependStatusGreenText: qoPrependStatusGreenText,
            prependStatusYellowText: qoPrependStatusYellowText,
            prependStatusRedText: qoPrependStatusRedText,
            onlyShowPrependStatusText: qoOnlyShowPrependStatusText,
            dashoGMapZoom: qoDashoGmapZoom,
            dashoGMapCenter: qoDashoGmapCenter
        };

        setQuery(oQs);
    }, []);

    const selectedProject = geoNow.stateHelper.project.getJoinedProjectItemByProjectId(
        qoProjectId || rdx_project.currentProjectId, rdx_project.joinedProjects);

    if (qoProjectId) {
        rdx_project.currentProjectId = qoProjectId;
        //let proj = geoNow.stateHelper.project.getJoinedProjectItemByProjectId(qoProjectId, rdx_project.joinedProjects);
        //setSelectedProject(proj);

    }
    if (qoToken) {
        token = qoToken;
    }

    const { resources, errors: dashboardErrors, loading: dashboardLoading, retry: retryResources } = useDashboardResources(
        selectedProject?.projectId, token, Boolean(selectedProject?.projectDescriptionImage)
    );
    const descriptionImageUrl = resources.descriptionImageUrl;
    const projectKmls = resources.kmls;
    const gageDefinitionsMap = React.useMemo(() => buildGageDefMapSafe(resources.definitions), [resources.definitions]);
    const mapItems = React.useMemo(() => buildDashboardMapItems(
        resources.instruments, resources.status?.entries,
        code => getGageTypeKeyFromMap(code, gageDefinitionsMap)
    ), [resources.instruments, resources.status, gageDefinitionsMap]);
    const validInsExCoordItems = React.useMemo(() => mapItems.items.filter(isDashboardMapItem), [mapItems]);
    const dupCoordItems = mapItems.coordinateGroups;
    const statusMeaTime = resources.status?.meaTime || null;
    const [statusShowingIdOfProjects, setStatusShowingIdOfProjects] = React.useState([]);
    const [hcItems, setHcItems] = React.useState([]);
    const [kmlLoadError, setKmlLoadError] = useState(null);
    const [kmlLoading, setKmlLoading] = useState(false);
    const [kmlBounds, setKmlBounds] = useState(null);
    const [mapRuntimeError, setMapRuntimeError] = useState(null);
    const [mapLoadTimedOut, setMapLoadTimedOut] = useState(false);
    const [mapAttempt, setMapAttempt] = useState(0);
    React.useLayoutEffect(() => {
        setKmlLoadError(null);
        setKmlLoading(false);
        setKmlBounds(null);
        setMapRuntimeError(null);
    }, [selectedProject?.projectId]);
    const retryDashboard = () => {
        setMapAttempt(value => value + 1);
        setMapRuntimeError(null);
        setKmlLoadError(null);
        setKmlBounds(null);
        retryResources();
    };
    const mapDivRef = useRef(null);
    const [gmap, setGmap] = useState(null);
    const [isFullscreen, setIsFullscreen] = useState(false);
    // LoadScript 會在 Dashboard 卸載時刪除 window.google；Google Maps 尚未執行完的
    // callback 隨後會拋出 "google is not defined"。hook loader 不會在換頁時清除全域 API。
    const { isLoaded: isGoogleMapsLoaded, loadError: googleMapsLoadError } = useJsApiLoader({
        // No KmlLayer dependency. The quarterly channel reduces provider churn.
        version: process.env.REACT_APP_GOOGLE_MAPS_CHANNEL || 'quarterly',
        googleMapsApiKey: "AIzaSyApF0vxBJzGfApnvdR0V9NA6QfVFGV2FLY"
    });

    useEffect(() => {
        const onFsChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };
        document.addEventListener("fullscreenchange", onFsChange);
        return () => document.removeEventListener("fullscreenchange", onFsChange);
    }, []);




    const history = useHistory();

    const [activeMarker, setActiveMarker] = useState(null);
    const handleActiveMarker = (marker) => {
        if (marker === activeMarker) {
            return;
        }
        setActiveMarker(marker);
    };

    const handleOnLoad = (map) => {
        setGmap(map);
        mapDivRef.current = map.getDiv(); // 把原始 map div 記下來，為了後續插入全螢幕按鈕到 MAP 內部。
    };

    useEffect(() => {
        if (!gmap) return;
        try {
            if (query?.dashoGMapCenter && query?.dashoGMapZoom) {
                const [lat, lng] = String(query.dashoGMapCenter).split(',').map(Number);
                const zoom = Number(query.dashoGMapZoom);
                if (Number.isFinite(lat) && Number.isFinite(lng) && Number.isFinite(zoom) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180) {
                    gmap.setCenter({ lat, lng });
                    gmap.setZoom(Math.max(0, Math.min(24, zoom)));
                }
            } else if (validInsExCoordItems.length > 0 || kmlBounds) {
                const bounds = new window.google.maps.LatLngBounds();
                validInsExCoordItems.forEach(item => bounds.extend(item.position));
                if (kmlBounds) {
                    bounds.extend({ lng: kmlBounds.west, lat: kmlBounds.south });
                    bounds.extend({ lng: kmlBounds.east, lat: kmlBounds.north });
                }
                gmap.fitBounds(bounds);
            }
        } catch {
            setMapRuntimeError('地圖範圍調整失敗，其他功能仍可使用。');
        }
    }, [gmap, validInsExCoordItems, kmlBounds, query]);

    useEffect(() => {
        setMapLoadTimedOut(false);
        if (isGoogleMapsLoaded || googleMapsLoadError) return;
        const timer = setTimeout(() => setMapLoadTimedOut(true), 15000);
        return () => clearTimeout(timer);
    }, [isGoogleMapsLoaded, googleMapsLoadError]);

    const hasNoKml = !Array.isArray(projectKmls) || projectKmls.length === 0;
    const hasMapContent = validInsExCoordItems.length > 0 || !hasNoKml;


    function buildGageDefMapSafe(resGageDef) {
        try {
            // 1) 形狀檢查：items[0] 要是陣列
            const list = Array.isArray(resGageDef?.items?.[0]) ? resGageDef.items[0] : [];
            // 2) 過濾掉沒有 code 的條目（後端 Code 是 int?）
            const cleaned = list.filter(d => d && d.code != null);

            // 3) 空資料：回傳空 Map（不中斷畫面）
            if (cleaned.length === 0) return new Map();

            // 4) 建 Map（統一 key 型別）
            return new Map(cleaned.map(d => [String(d.code), d]));
        } catch (err) {
            console.error("[GageDefinition] build map failed:", err);
            return new Map(); // 失敗也回空 Map，避免後續渲染爆掉
        }
    }
    function getGageTypeKey(gageTypeCode) {
        if (!gageDefinitionsMap) return String(gageTypeCode);
        const def = gageDefinitionsMap.get(String(gageTypeCode));
        // 後端的模型：Code(int?)、GageType(string)、Abbreviation(string)
        // 主要要拿 GageType；若沒有可退而求其次
        return def?.gageType ?? def?.abbreviation ?? String(gageTypeCode);
    }
    function getGageTypeKeyFromMap(gageTypeCode, map) {
        if (!map) return String(gageTypeCode);
        const def = map.get(String(gageTypeCode));
        return def?.gageType ?? def?.abbreviation ?? String(gageTypeCode);
    }



    function renderStatusMarkerInfoWindowContent(pointIdx, pointNo, position, value, exceedWarning, note, isFirstElement = false) {
        const divClassName = isFirstElement ? "pt-1" : "border-top border-info mt-1 pt-2";
        return (

            /*<div className="border-bottom border-info mb-1">*/
            <div className={divClassName} style={{ overflowX: 'hidden' }}>
                <Row>
                    <Col><h5><span>{pointNo}</span></h5></Col>
                    <Col xs="auto"><Button variant="info" size="sm" onClick={e => {
                        let tempDtRight = moment(statusMeaTime.meaTime).add(30, "minutes");
                        let tempDtLeft = moment(statusMeaTime.meaTime).add(-1, "days");
                        history.push({
                            pathname: Routes.TimeHistory.path,
                            state: {
                                dtLeft: tempDtLeft,
                                dtRight: tempDtRight,
                                pointIndices: Array.of(pointIdx)
                            }
                        });
                    }}><FontAwesomeIcon icon={faChartLine} /></Button></Col>
                </Row>
                <Row className="pb-1">
                    <Col>{value === null ? '沒有訊號' : `物理量: ${value}`}<span className="text-danger">{!note || note === '' || note === null ? "" : `：${note}`}</span></Col>
                </Row>
            </div>
        );
    }

    const parseIntOr = (v, fallback) => {
        const n = Number.parseInt(v, 10);
        return Number.isNaN(n) ? fallback : n;
    };

    function createLabelSvgUrl(text) {
        const defaultTextSize = 14;
        const textSize = parseIntOr(selectedProject?.projectMapPointTextSize, defaultTextSize);
        const textColor = selectedProject.projectMapPointTextColor ?? "white";
        const textStrokeColor = selectedProject.projectMapPointTextBorderColor ?? "black";
        const textLength = text.length * textSize;
        
        return `data:image/svg+xml;utf-8,` +
            `<svg xmlns="http://www.w3.org/2000/svg" width="${textLength + 4}" height="${20 * textSize / defaultTextSize}">` +
            `<text x="0" y="${12 * textSize / defaultTextSize}" font-size="${textSize}" stroke="${textStrokeColor}" stroke-width="3">${text}</text>` +
            `<text x="0" y="${12 * textSize / defaultTextSize}" font-size="${textSize}" fill="${textColor}">${text}</text>` +
            `</svg>`;
    }

    function simplifyLabels(labels) {
        const grouped = {};
        const ungrouped = [];

        labels.forEach(label => {
            const mainPart = label.match(/^[^-]+/)[0];
            if (!grouped[mainPart]) {
                grouped[mainPart] = [];
            }
            grouped[mainPart].push(label);
        });

        const simplified = [];
        for (const [mainPart, fullLabels] of Object.entries(grouped)) {
            const suffixes = fullLabels.map(label => label.slice(mainPart.length));
            if (suffixes.every(suffix => ["-X", "-Y", "-Z"].includes(suffix.toUpperCase()))) {
                simplified.push(mainPart);
            } else {
                ungrouped.push(...fullLabels);
            }
        }

        return { simplified, ungrouped };
    }

    function getMarkerLabelText(pointIdx, pointNo, position, value, exceedWarning, note, jsxMasterExceedWarning, dupCoordItems) {
        let lbl = getDupText(pointNo, position, dupCoordItems);
        let prependText = "";
        const light = getStatusLightForScore(jsxMasterExceedWarning, selectedProject);
        if (light.color === 'gray') {
            prependText = qs?.prependStatusGrayText || '無訊號';
        } else if (light.color === 'yellow') {
            if (qoPrependStatusYellowText) {
                prependText = qoPrependStatusYellowText;
            }
        } else if (light.color === 'red') {
            if (qoPrependStatusRedText) {
                prependText = qoPrependStatusRedText;
            }
        } else {
            if (qoPrependStatusGreenText) {
                prependText = qoPrependStatusGreenText;
            }
        }

        if (qoOnlyShowPrependStatusText) {
            // 只顯示狀態文字
            lbl = prependText;
        } else {
            // 顯示狀態文字 + Marker 文字
            lbl = `${prependText} ${lbl}`;
        }

        return lbl;
    }

    function getDupText(pointNo, position, dupCoordItems) {
        const key = `${position.lng},${position.lat}`;
        if (dupCoordItems[key]) {
            const childPoints = dupCoordItems[key].children.map(d => d.pointNo);
            const { simplified, ungrouped } = simplifyLabels([pointNo, ...childPoints]);

            let result = simplified.join(", ");
            if (ungrouped.length > 0) {
                if (childPoints.length > 3) {
                    result += `, ${ungrouped.slice(0, 2).join(", ")},...${ungrouped.length}`;
                } else {
                    result += `, ${ungrouped.join(", ")}`;
                }
            }

            // trim ", " from the beginning
            if (result.startsWith(", ")) {
                result = result.slice(2);
            }

            return result;
        }
        return pointNo;
    }



    if (!selectedProject) {
        return (
            <div>
                <h2>未指定專案</h2>
            </div>
        );
    }

    const toggleMapType = () => {
        if (gmap) {
            try {
                const currentType = gmap.getMapTypeId();
                gmap.setMapTypeId(currentType === "roadmap" ? "satellite" : "roadmap");
            } catch { setMapRuntimeError('地圖切換失敗，請重新載入地圖。'); }
        }
    };

    const toggleGoogleMapFullscreen = () => {
        try {
            const action = !document.fullscreenElement ? gmap?.getDiv()?.requestFullscreen() : document.exitFullscreen();
            action?.catch(() => setMapRuntimeError('瀏覽器無法開啟地圖全螢幕，其他功能仍可使用。'));
        } catch { setMapRuntimeError('瀏覽器不支援地圖全螢幕。'); }
    };


    return (
        <>
            {(!qoHideDashoTitle || !qoHideDashoDesc) &&
                <Row>
                    <Col>
                        {!qoHideDashoTitle &&
                            <h2>{selectedProject.projectName}</h2>
                        }
                        {
                            !qoHideDashoDesc &&
                            <p>{selectedProject.projectDescription}</p>
                        }
                    </Col>
                </Row>
            }
            {!qoHideDashoImg && selectedProject.projectDescriptionImage && selectedProject.projectDescriptionImage !== "" &&
                <Row>
                    <Col>
                        <img src={descriptionImageUrl} />
                    </Col>
                </Row>
            }
            {false &&
                <Row>
                    <Carousel>
                        {
                            hcItems.map((item, index) => {

                                if (item.disabled) {
                                    return ("");
                                }

                                if (item.mediaType === 0) {
                                    return (
                                        <Carousel.Item key={index}>
                                            <img
                                                className="d-block w-100"
                                                src={item.imageUrl}
                                                alt={item.imageAlt}
                                            />
                                            <Carousel.Caption>
                                                <h3>{item.title}</h3>
                                                <p>{item.description}</p>
                                            </Carousel.Caption>
                                        </Carousel.Item>
                                    );
                                } else if (item.mediaType === 1) {
                                    // video
                                    return (
                                        <Carousel.Item key={index}>
                                            <video
                                                className="d-block w-100"
                                                src={item.videoUrl}
                                                controls
                                            />
                                            <Carousel.Caption>
                                                <h3>{item.title}</h3>
                                                <p>{item.description}</p>
                                            </Carousel.Caption>
                                        </Carousel.Item>
                                    );
                                }
                            })
                        }
                        <Carousel.Item interval={1000}>
                            <img
                                className="d-block w-100"
                                src="holder.js/800x400?text=First slide&bg=373940"
                                alt="First slide"
                            />
                            <Carousel.Caption>
                                <h3>First slide label</h3>
                                <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                            </Carousel.Caption>
                        </Carousel.Item>
                        <Carousel.Item interval={500}>
                            <img
                                className="d-block w-100"
                                src="holder.js/800x400?text=Second slide&bg=282c34"
                                alt="Second slide"
                            />
                            <Carousel.Caption>
                                <h3>Second slide label</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                            </Carousel.Caption>
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100"
                                src="holder.js/800x400?text=Third slide&bg=20232a"
                                alt="Third slide"
                            />
                            <Carousel.Caption>
                                <h3>Third slide label</h3>
                                <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
                            </Carousel.Caption>
                        </Carousel.Item>
                    </Carousel>
                </Row>
            }
            {false && <Row>
                <Col>
                    <Image src={WhiteRiverPicture} fluid />
                </Col>
            </Row>
            }
            <div className="mb-3 d-flex align-items-center justify-content-between flex-wrap">
                <span role="status" aria-live="polite">
                    {dashboardLoading ? '專案資料載入中，可繼續切換專案或使用其他功能。' : kmlLoading ? 'KML 底圖載入中，其他功能可正常使用。' : ''}
                </span>
                <Button variant="outline-primary" size="sm" onClick={retryDashboard}>重新載入</Button>
            </div>
            {(dashboardErrors.length > 0 || googleMapsLoadError || mapLoadTimedOut || kmlLoadError || mapRuntimeError) && (
                <Alert variant="warning" role="alert">
                    <div>部分內容無法載入，已保留其他可用功能。</div>
                    {dashboardErrors.map(message => <div key={message}>{message}</div>)}
                    {(googleMapsLoadError || mapLoadTimedOut) && <div>Google 地圖載入失敗或逾時，請檢查網路後重試。</div>}
                    {kmlLoadError && <div>{kmlLoadError}</div>}
                    {mapRuntimeError && <div>{mapRuntimeError}</div>}
                </Alert>
            )}
            <Row>
                {!hasMapContent ? (
                    <Col xs={12}>
                        <Alert variant="info">
                            {dashboardLoading ? '正在載入專案地圖資料。' : '此專案沒有可顯示的儀器座標或 KML 底圖。'}
                        </Alert>
                    </Col>
                ) : (
                    <>
                        {hasNoKml && (
                            <Col xs={6}>
                                <Alert variant="info">
                                    該專案無提供經簡化之 CAD 或最終 KML。
                                </Alert>
                            </Col>
                        )}
                        {/*業主有給 KML 就讓按鈕控制項占整列，這樣顯示才不會讓按鈕跑到中間，正確貼齊右邊。*/}
                        <Col xs={hasNoKml ? 6 : 12} className="mb-1 text-end">
                            <Button variant="info" onClick={toggleMapType}>衛星／道路</Button>{' '}
                            <Button variant="info" onClick={toggleGoogleMapFullscreen}>地圖全螢幕</Button>
                        </Col>
                    </>
                )}

                <Col xs={12} data-kmls-count={projectKmls === null ? 0 : projectKmls.length}>

                    {isGoogleMapsLoaded && hasMapContent &&
                        <FeatureErrorBoundary name="地圖" resetKey={`${selectedProject.projectId}:${mapAttempt}`}>
                            <GoogleMap
                                key={`${selectedProject.projectId}:${mapAttempt}`}
                                onUnmount={() => { setGmap(null); mapDivRef.current = null; }}
                                zoom={1}
                                onLoad={handleOnLoad}
                                onClick={() => setActiveMarker(null)}
                                mapContainerStyle={{ width: "100%"/*"100vw"*/, height: "95vh" }}
                                options={{
                                    fullscreenControl: false
                                }}
                            >
                                {validInsExCoordItems.map(({ pointIdx, pointNo, gageTypeCode, jsxGageTypeKey, position, value, exceedWarning, note, jsxMasterExceedWarning }) => (
                                    <React.Fragment key={pointIdx}>
                                        <Marker
                                            key={pointIdx}
                                            position={position}
                                            label={{
                                                text: " ",
                                                className: 'markerLabelPointNo'
                                            }}
                                            onClick={() => handleActiveMarker(pointIdx)}
                                            icon={{
                                                url: (() => {
                                                    ////註解掉因為重構至 Promise 取得資料後，避免將邏輯寫在這裡 (避免重複計算)
                                                    //let warn_lv = standardizeWarnScore(value, exceedWarning);
                                                    //let dupParent = dupCoordItems[`${position.lng},${position.lat}`];
                                                    //if (dupCoordItems && dupParent && dupParent.children && dupParent.children.length > 0) {
                                                    //    //作為群集，必須要所有都正常才綠燈，任何一個有異常，都要以最嚴格狀態看待。
                                                    //    for (let i = 0; i < dupParent.children.length; i++) {
                                                    //        let child_warn_lv = standardizeWarnScore(dupParent.children[i].value, dupParent.children[i].exceedWarning);
                                                    //        if (child_warn_lv > warn_lv) {
                                                    //            warn_lv = child_warn_lv;
                                                    //        }
                                                    //    }
                                                    //}

                                                    //let warn_lv = jsxMasterExceedWarning; // 0: None (Normal / Green), 0.5: Alert, 1: Alarm1, 1.5: Alarm2, 2: Action
                                                    ////console.log(`ICON: ${pointNo} ${gageTypeCode}`);
                                                    ////debugger;
                                                    //if (warn_lv === 0.5) {
                                                    //    return MarkerIconYellow;
                                                    //}
                                                    //else if (warn_lv >= 1) {
                                                    //    return MarkerIconRed;
                                                    //} else {
                                                    //    return MarkerIconGreen;
                                                    //}
                                                    const typeKey = (/* 每筆項目 */ jsxGageTypeKey) ?? getGageTypeKey(gageTypeCode);
                                                    return getPresetIconUrl(typeKey, jsxMasterExceedWarning);

                                                })(),
                                                labelOrigin: { x: 0, y: 20 },
                                                anchor: { x: selectedProject.projectMapPointTextOffsetX ?? 8, y: selectedProject.projectMapPointTextOffsetY ?? 8 }
                                            }}
                                        >
                                            {activeMarker === pointIdx ? (
                                                <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                                    <>
                                                        {
                                                            (renderStatusMarkerInfoWindowContent(pointIdx, pointNo, position, value, exceedWarning, note, true))
                                                        }
                                                        {
                                                            (!dupCoordItems[`${position.lng},${position.lat}`] ? '' :
                                                                dupCoordItems[`${position.lng},${position.lat}`].children.map(x => renderStatusMarkerInfoWindowContent(x.pointIdx, x.pointNo, x.position, x.value, x.exceedWarning)))

                                                        }
                                                    </>
                                                </InfoWindow>
                                            ) : null}
                                        </Marker>
                                        <Marker
                                            onClick={() => handleActiveMarker(pointIdx)}
                                            position={position}
                                            icon={{
                                                /*url: createLabelSvgUrl(getDupText(pointNo, position, dupCoordItems)),*/
                                                url: createLabelSvgUrl(getMarkerLabelText(pointIdx, pointNo, position, value, exceedWarning, note, jsxMasterExceedWarning, dupCoordItems)),
                                                anchor: { x: 0, y: 0 },
                                                labelOrigin: { x: 0, y: 0 }
                                            }}
                                        />
                                    </React.Fragment>
                                ))}
                                <ProjectKmlLayers layers={projectKmls} projectId={selectedProject.projectId} onError={setKmlLoadError} onLoading={setKmlLoading} onBounds={setKmlBounds} />
                            </GoogleMap>
                        </FeatureErrorBoundary>
                    }
                </Col>
            </Row>
            {isFullscreen && mapDivRef.current && createPortal(
                <Button
                    variant="danger"
                    onClick={toggleGoogleMapFullscreen}
                    style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        zIndex: 9999
                    }}
                >
                    退出全螢幕
                </Button>,
                mapDivRef.current
            )}
        </>
    );
};
